module.exports = __webpack_public_path__ + "models/total station.695f3d1b.gltf";